<script>
    import Design2021ApprenticeDataTable from '../../common/design-2021-apprentice-data-table.vue';

    export default {
        name: 'design-2021-analytics-untagged-groups-component',
        components: { Design2021ApprenticeDataTable },
        props: {
            untaggedGroupsIn: {
                type: Array
            }
        },
        data() {
            return {
                untaggedGroups: this.untaggedGroupsIn,
                fields: [
                    {
                        key: 'name',
                        label: this.$t('common.name'),
                        sortable: true
                    },
                    {
                        key: 'school_name',
                        label: this.$t('common.school'),
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: this.$t('common.actions')
                    }
                ],
                selectedGroup: null
            };
        },
        computed: {
            tableData() {
                return this.untaggedGroups.map((group) => {
                    group.school_name = group.school.name;
                    return group;
                });
            }
        },
        methods: {
            updateGroups(group) {
                this.untaggedGroups = this.untaggedGroups.filter((group0) => group0.id !== group.id);
            },
            goToGroup(group) {
                window.location.href = this.routes.adminGoToGroup(group.id);
            },
            showGroupLinkModal(group) {
                this.$refs.analyticsGroupLinkModal.show(group);
            }
        }
    };
</script>

<template>
    <div class="apprentice-simple-card">
        <design2021-apprentice-data-table
            :fields="fields"
            :items="tableData">
            <template #cell(actions)="data">
                <div class="management-actions">
                    <b-button
                        class="btn-open"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('analytics.to_group')"
                        @click="goToGroup(data.item)">
                    </b-button>

                    <b-button
                        class="btn-tags"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('analytics.add_tags')"
                        @click="showGroupLinkModal(data.item)">
                    </b-button>
                </div>
            </template>
        </design2021-apprentice-data-table>
        <design-2021-analytics-group-link-modal
            @groupUpdated="updateGroups"
            ref="analyticsGroupLinkModal">
        </design-2021-analytics-group-link-modal>
    </div>
</template>

<style scoped lang="scss">

</style>